import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-4">
          <button
            data-testid="gallery-back-btn"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-semibold">Back to Home</span>
          </button>
          <div className="bg-blue-50 border border-blue-100 rounded-lg px-3 py-1.5">
            <div className="text-[10px] uppercase tracking-widest text-blue-600 font-bold">ProClean</div>
            <div className="text-sm font-bold text-slate-900">Our Recent Work</div>
          </div>
        </div>
      </header>
      <Gallery />
    </div>
  );
};

export default GalleryPage;
